module.exports = __webpack_public_path__ + "static/media/budget-icon.10ba6e81.svg";